import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getSecureItem } from "../../utils/secureStorage";
const WhatsNewtext = () => {
    const user = getSecureItem('UserData');
    const { t } = useTranslation();
    return (
        <Card className="mb-4">
            <Card.Header
                className="bg-transparent d-flex align-items-center"
                style={{ height: '50px' }}
            >
                <div className="d-flex align-items-center">
                    <Card.Title className="mb-0">Contact</Card.Title>
                </div>
            </Card.Header>
            <Card.Body>
                <Card.Title></Card.Title>
                {/* <Card.Text>Pour toute question ou en cas de besoin, notre service client est à votre écoute. Vous pouvez nous contacter à tout moment via le chatbot intégré à la plateforme, par téléphone au 01 76 39 01 95, ou par mail à l’adresse suivante : <a href="mailto:contact@symvisionlab.fr">contact@symvisionlab.fr</a>
                                    </Card.Text> */}
                <Card.Text>
                    Au besoin, vous pouvez nous contacter à tout moment :<br />
                    <ul>
                        <li>Par chat en bas à droite</li>
                         {user?.userType == "OPTICIAN" ? <li>Par téléphone au <a href="tel:+0176390195">01 76 39 01 95</a></li> : 
                        <li>
                            Par téléphone au{' '}
                            <a href="tel:+0142181184">01 42 18 11 84</a>
                        </li>}
                        <li>
                            Par mail à{' '}
                            {user?.userType == 'OPTICIAN' ? (
                                <a href="mailto:opticien@symcarelab.fr">
                                    opticien@symcarelab.fr
                                </a>
                            ) : (
                                <a href="mailto:contact@sym-lab.com">
                                    contact@sym-lab.com
                                </a>
                            )}
                        </li>
                    </ul>
                </Card.Text>

                {/* <Card.Text>L’interface de l’application a été entièrement repensée pour vous offrir une expérience plus fluide, intuitive et agréable, dès votre première connexion.<br /><br />
                                        Pour toute question ou en cas de besoin, notre service client est à votre écoute. Vous pouvez nous contacter à tout moment via le chatbot intégré à la plateforme, par téléphone au 01 76 39 01 95, ou par mail à l’adresse suivante : <a href="mailto:contact@symvisionlab.fr">contact@symvisionlab.fr</a></Card.Text> */}
            </Card.Body>
        </Card>
    );
};
export default WhatsNewtext;